<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div>
      <app-dmc-quote-terms-conditions 
      (makeFormDirty)="markFormDirty($event)" 
      [hideFooter]="true" 
      [leadId]="leadId" 
      [itineraryId]="itineraryId" 
      (storeFormData)="storeTermsAndConditionsData($event)" 
      [storedFormData]="termsAndConditionsFormData" 
      [editQuote]="editQuote? true : false"
      ></app-dmc-quote-terms-conditions>
    </div>
    <div *ngIf="leadId">
      <app-dmc-quote-payments-terms-conditions 
      (makeFormDirty)="markFormDirty($event)" 
      [hideFooter]="true" 
      [leadId]="leadId" 
      [itineraryId]="itineraryId" 
      (storeFormData)="storePaymentTermsAndConditionsData($event)" 
      [storedFormData]="paymentTermsAndConditionsFormData" 
      [editQuote]="editQuote? true : false"
      ></app-dmc-quote-payments-terms-conditions>
    </div>
    <div>
      <app-dmc-quote-cancellation-policy 
      (makeFormDirty)="markFormDirty($event)" 
      [hideFooter]="true" 
      [leadId]="leadId" 
      [itineraryId]="itineraryId" 
      (storeFormData)="storeCancellationPolicyData($event)" 
      [storedFormData]="cancellationPolicyFormData" 
      [editQuote]="editQuote? true : false"
      ></app-dmc-quote-cancellation-policy>
    </div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified() && termsAndConditionsFormData">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified() && termsAndConditionsFormData">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
  
</div>